module.exports = __webpack_public_path__ + "img/Intersect@2x.60209ff7.png";